import { getProducts, postLinkedProduct, postSyncProducts } from '@utils/ajax';
import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { createFlashMessage } from '@components/Flash/redux';
import {
  setLoadingProducts,
  setLoadingSyncProducts,
  setProducts
} from './actions';

function* fetchProducts() {
  try {
    yield put(setLoadingProducts(true));
    const { data: products } = yield call(getProducts);

    if (products) {
      yield put(setProducts(products));
    }
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'error',
        message: error.result.message || 'Falha ao buscar produtos',
        variables: { dismissible: true }
      })
    );
  } finally {
    yield put(setLoadingProducts(false));
  }
}

function* updateLinkedProduct({ payload }) {
  try {
    console.log('Updating linked product with payload:', payload);
    const { data } = yield call(postLinkedProduct, payload);
    console.log('Response from postLinkedProduct:', data);

    if (data.result.success) {
      yield put(
        createFlashMessage({
          type: 'success',
          message: data.result.message,
          variables: { dismissible: true }
        })
      );
      yield delay(1000);
      yield call(syncProducts);
    } else {
      yield put(
        createFlashMessage({
          type: 'error',
          message:
            data.result.message || 'Falha ao atualizar o produto vinculado',
          variables: { dismissible: true }
        })
      );
    }
  } catch (error) {
    console.log('Error updating linked product:', error);
    yield put(
      createFlashMessage({
        type: 'error',
        message:
          error.result.message || 'Falha ao atualizar o produto vinculado',
        variables: { dismissible: true }
      })
    );
  }
}

function* syncProducts() {
  try {
    console.log('Syncing products...');
    yield put(setLoadingSyncProducts(true));
    const { data } = yield call(postSyncProducts);
    if (data.result.success) {
      yield call(fetchProducts);
    } else {
      yield put(
        createFlashMessage({
          type: 'error',
          message: data.result.message || 'Falha ao sincronizar produtos',
          variables: { dismissible: true }
        })
      );
    }
  } catch (error) {
    yield put(
      createFlashMessage({
        type: 'error',
        message: error.result.message || 'Falha ao sincronizar produtos',
        variables: { dismissible: true }
      })
    );
  } finally {
    yield put(setLoadingSyncProducts(false));
  }
}

export function createProductSaga(types) {
  return [
    takeLatest(types.fetchProducts, fetchProducts),
    takeLatest(types.updateLinkedProduct, updateLinkedProduct),
    takeLatest(types.syncProducts, syncProducts)
  ];
}
